import React from 'react'
import {Link, withRouter} from 'react-router-dom'
import defaultUserImage from 'assets/img/defaults/profile_default_v01.png'
import addChildIcon from 'assets/img/icons/icon_child_plus_v02.png'
import gears from 'assets/img/icons/icon_gears_v01.png'
import getDate from 'utils/get-date'

const styles = {
  addChild: {
    background: 'url(' + addChildIcon + ')',
    display: 'inline-block',
    width: '99px',
    height: '30px',
    backgroundSize: '99px 30px',
    textIndent: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  gearsIcon: {
    display: 'inline-block',
    background: 'url(' + gears + ') no-repeat',
    backgroundSize: '30px 60px',
    width: '30px',
    height: '30px'
  }
}

const UserHeader = props => {
  function checkAvatar() {
    let profileImage

    if (props.user.user_info === undefined || props.user.user_info.avatar_url === '') {
      profileImage = defaultUserImage
    } else {
      profileImage = props.user.user_info.avatar_url
    }

    return profileImage
  }

  return (
    <div id="donor_profile_header" className="island">
      <div className="donor-profile-image">
        <img src={checkAvatar()} alt="Donor Profile" />
      </div>

      <h2>{props.user.given_name} {props.user.family_name}</h2>

      <div className="row">
        <div className="col-sm-4">
          <div className="field member-since-field">
            <div className="field-label">Sponsor since:</div>
            <div className="field-item">{getDate(props.user.start_of_sponsorship)}</div>
          </div>

          <div className="form-item form-type-item">
            <div className="field"><div className="field-label">Sponsor ID:</div><div className="field-item">{props.user.partner_id}</div></div>
          </div>
        </div>

        <div className="col-sm-8">

          <div id="sposored-children-group">
            <h3 className="visible-xs">Sponsored Children</h3>
            <div className="form-item form-type-item">
              {/* <ul className="child-links">
                <li>
                  <a href="/my-child/lyzon-merl-justimbaste" title="Lyzon Merl Justimbaste">
                    <img src="https://myspon.worldvision.org.ph/sites/default/files/styles/50x50/public/child_import_images/336ae73b9d96c2121133d0df62471be3.jpg?itok=RBcoQuYf" alt=""/>
                  </a>
                </li>
                <li>
                  <a href="/my-child/ricky-jr-navarrete" title="Ricky Jr Navarrete">
                    <img src="https://myspon.worldvision.org.ph/sites/default/files/styles/50x50/public/child_import_images/31bd8e174c5f2a4619ed6b25209db29d.jpg?itok=FCwz8EAi" alt=""/>
                  </a>
                </li>
              </ul> */}
            </div>
          </div>

          <div id="block-block-26">
            <p>
              <a href="https://www.worldvision.org.ph/sponsor-child/" target="_blank" rel="noopener noreferrer" title="Sponsor another child"><span style={styles.addChild}></span><span className="link-text visible-xs">Sponsor another child</span></a>
            </p>
          </div>

        </div>
      </div>

      <div className="edit-my-profile-link">
        <Link to={`${props.match.url}/edit`} title="Edit my profile">
          <span style={styles.gearsIcon}></span>
          <span className="link-text hidden-xs">Edit my profile</span>
        </Link>
      </div>
    </div>
  )
}

export default withRouter(UserHeader)
